import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
	faXmark,
	faChevronUp,
	faChevronDown,
	faAngleRight,
	faArchive,
	faCheck,
	faEye,
	faPencilAlt,
	faTable,
	faTableCellsLarge,
	faTag,
	faTimes,
	faUpload,
	faWrench,
	faFilter,
	faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { accordionInterface } from 'src/app/util/interfaces/accordion';
import { kbArchiveInterface } from 'src/app/util/interfaces/kbArchive';
import { logInterface } from 'src/app/util/interfaces/log.interface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { KnowledgeBasePageService } from './service/knowledge-base-page.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { knowledgeManagementTagsInterface } from 'src/app/util/interfaces/knowledgeManagementTags';
import { kmClassificationInterface } from 'src/app/util/interfaces/kmClassification';
import { requestInterface } from 'src/app/util/interfaces/request';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { PermissionService } from 'src/app/util/services/permission/permission.service';

import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { MspTableService } from 'src/app/page_component_item/msp-table/service/msp-table.service';
import { DateService } from 'src/app/services/date/date.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
// import { AngularMarkdownEditorModule, EditorOption } from 'angular-markdown-editor';

@Component({
	selector: 'app-knowledge-base-page-rework',
	templateUrl: './knowledge-base-page-rework.component.html',
	styleUrls: ['./knowledge-base-page-rework.component.scss'],
})
export class KnowledgeBasePageReworkComponent implements OnInit {
	//editorOptions!: EditorOption;

	icons = {
		faPencilAlt: faPencilAlt,
		faEye: faEye,
		faCheck: faCheck,
		faUpload: faUpload,
		faArchive: faArchive,
		faWrench: faWrench,
		faTimes: faTimes,
		faAngleRight: faAngleRight,
		faTag: faTag,
		faTable: faTable,
		faTableCellsLarge: faTableCellsLarge,
		faFilter: faFilter,
		faPlus: faPlus,
		faChevronUp: faChevronUp,
		faChevronDown: faChevronDown,
		faXmark: faXmark,
	};

	classificationOptions = {
		isEditingClassification: true,
		disabled: false,
		selectedCustomer: null,
		hideField: ['severity'],
		initOn: 'serviceType',
		thisAnalystOnly: false,
	};

	editorConfig: AngularEditorConfig = {
		editable: true,
		translate: 'no',
		outline: false,
		toolbarHiddenButtons: [
			[
				// 'undo',
				// 'redo',
				// 'heading',
				// 'fontName'
			],
			[
				// 'customClasses',
				// 'insertImage',
				// 'insertVideo',
				// 'insertHorizontalRule',
				// 'removeFormat',
				// 'toggleEditorMode'
			],
		],
	};

	labels: LabelsInterface = {
		lbl_geral_arquivos: 'Files',
		lbl_meus_artigos: 'My articles',
		lbl_chat_TranfArquivos: 'Upload Files',
		lbl_geral_tipo: 'Type',
		lbl_edocs_carregando: 'Loading',
		lbl_geral_esboco: 'Draft',
		lbl_revisao_tecnica: 'Technical Review',
		lbl_revisao_driver: 'Driver Review',
		lbl_edocs_publicado: 'Published',
		lbl_geral_arquivado: 'Filed',
		lbl_relacionado_problema: 'Problem Related',
		lbl_relacionado_incident: 'Incident Related',
		lbl_select_scope: 'Select a scope',
		lbl_geral_informacoes: 'Informations',
		lbl_geral_selecione: 'SELECT',
		lbl_geral_idioma: 'Language',
		lbl_geral_portugues: 'Portuguese',
		lbl_geral_ingles: 'English',
		lbl_geral_espanhol: 'Spanish',
		lbl_geral_eslovaco: 'Slovak',
		lbl_geral_chines: 'Chinese',
		lbl_geral_italiano: 'Italian',
		lbl_geral_cliente: 'Customer',
		lbl_grupo: 'Grupo',
		lbl_geral_competencia: 'Scope',
		lbl_geral_natureza: 'Competence',
		lbl_geral_topico: 'Topic',
		lbl_geral_sites: 'Sites',
		lbl_geral_visibilidade: 'Visibility',
		lbl_geral_uso_interno: 'Internal use',
		lbl_edocs_publico: 'Public',
		lbl_kb_disponivel_cliente: 'Self-support',
		lbl_geral_classificar: 'Classify',
		lbl_geral_summary: 'Summary',
		lbl_geral_detalhamento: 'Description',
		lbl_status_analise_causa: 'Root cause analysis',
		lbl_asset_resolucao: 'Resolution',
		lbl_kb_aplica_se: 'Applies to',
		lbl_kb_criar: 'Create',
		lbl_chamado_aprovar: 'Approve',
		lbl_edocs_reprovar: 'Reject',
		lbl_arquivo_publicado_clicando_aqui: 'This file has already been published and can be opened by clicking',
		lbl_geral_aqui: 'here',
		lbl_arquivo_dado_como: 'This archive was given as',
		lbl_geral_obsoleto: 'obsolete',
		lbl_chamado_relacionado: 'Related request',
		lbl_geral_novo: 'New',
		lbl_preencha_todos_campos: 'Fill in all fields',
		lbl_erro_request_fields: 'Fill the mandatory fields',
		lbl_novo_arquivo: 'New archive',
		lbl_aguardando_driver: 'Awaiting driver approval',
		lbl_aguardando_tech: 'Awaiting technical approval',
		lbl_aguardando_voce: 'Awaiting your approval',
		lbl_tipo_relacionamento: '',
		lbl_relacionado_chamado: '',
		lbl_relacionado_classificacao: '',
		lbl_geral_classificacao: '',
		lbl_geral_salvar: '',
		lbl_geral_e: '',
		lbl_enviar_aprovacao: '',
		lbl_edocs_publicar: '',
		lbl_confirmar_reprovacao: '',
		lbl_geral_motivo: '',
		lbl_geral_excluir: '',
		lbl_escopo_classificacao: '',
		lbl_geral_versao: '',
		lbl_geral_as: '',
		lbl_geral_voltar: '',
		lbl_adicionar_nova_log: '',
		lbl_geral_comentarios: '',
		lbl_asset_informacoes_tecnicas: '',
		lbl_geral_criado_com_sucesso: '',
		lbl_successful_updated: '',
		lbl_retornar_para_esboco: '',
		lbl_preencha_todos_asteriscos: '',
		lbl_geral_inicio: '',
		lbl_sem_permissao_acao: '',
		lbl_geral_deletado_com_sucesso: '',
		lbl_reclassificacao_desativada_arquivo_pertence_a: '',
		lbl_selecione_uma_opcao: '',
		lbl_geral_continuar: '',
		lbl_adicionar_relacionamento: '',
		lbl_geral_adicionar: '',
		lbl_nenhum_item_tipo_registrado: '',
		lbl_cmdb: '',
		lbl_geral_chamado: '',
		lbl_adicionar_tag: '',
		lbl_selecione_tags_relacionadas: '',
		lbl_selecione_cliente_relacionar_artigo: '',
		lbl_selecione_uma_tag_relacionar: '',
		lbl_ja_adicionou_tag: '',
		lbl_security_nenhum_registro: 'No records found',
		lbl_preencha_pelo_menos_um_campo_para_continuar: 'Fill in at least one field to continue',
		lbl_geral_buscar: 'Search',
		lbl_geral_usuarios_encontrados: 'Users found',
		lbl_rep_custom_id_32: 'Requests List',
		lbl_geral_privado: '',
		lbl_geral_conteudo: '',
		lbl_projetos_resumo: '',
		lbl_edocs_interno: '',
		lbl_geral_artigo: '',
		lbl_vinculos: '',
		lbl_geral_adicionar_novo: '',
		lbl_cmdb_relacionamentos_adicionados: '',
		lbl_cmdb_relacionamento: '',
		lbl_titulo_artigo: '',
		lbl_informacoes_artigo: '',
		lbl_preencha_conteudo_artigo: '',
		lbl_adicione_relacionamento_continuar: '',
		lbl_preencha_informacoes_visibilidade_continuar: '',
		lbl_km_classificacoes_redefinidas: '',
		lbl_preencha_todos_campos_novo_relacionamento: '',
		lbl_necessario_pelo_menos_um_relacionamento: '',
		lbl_geral_nivel_acesso: '',
		lbl_geral_responsavel: '',
		lbl_geral_avaliar: 'Evaluate',
		lbl_geral_limpar_campos: '',
		lbl_preencha_nome: '',
	};

	constructor(
		private KnowledgeBasePageService: KnowledgeBasePageService,
		private LabelsService: LabelsService,
		private Router: Router,
		private ActivatedRoute: ActivatedRoute,
		private NotificationService: NotificationService,
		public ProfileService: ProfileService,
		public PermissionService: PermissionService,
		public MspTableService: MspTableService,
		public DateService: DateService
	) {
		this.kbClassificationFilter = this.kbClassificationFilter.bind(this);
	}

	isLoadingAccordion = true;
	isLoadingLabels = true;
	isLoadingForm = true;
	isLoadingKbArchive = false;
	isLoadingKbLogs = false;
	isLoadingNextStep = false;
	isLoadingSearchRequest = false;
	isLoadingRequestData = false;
	isOpenModalEvaluationMSP = false;
	isLoadingAvailableCustomer = false;

	userLanguage = 'English';

	kbAccordion: accordionInterface[];
	selectedAccordion: accordionInterface = {
		id: '',
		name: '',
		kb: [],
		type: 'kb',
		dataType: 'kb',
		border: '',
		alert: false,
		accordionLength: 0,
		hidden: false,
	};
	secondColView = 'not-chosen';
	draftStep = {
		name: 'customer',
		label: 'lbl_geral_nivel_acesso',
	};

	selectedTab = 'archiveData';
	selectedLogType = 'Registry';

	availableStatus = ['New', 'Draft', 'Driver approval', 'Tecnical review', 'Published'];
	selectedKb: kbArchiveInterface = {
		id: '',
		summary: '',
		description: '',
		status: 'New',
		visibility: '',
		language: '',
		active: null,
		approved: null,
		responsible: {
			id: '',
			fullName: '',
		},

		tags: [],
		classification: [],
		customer: [],
	};

	//Draft form
	availableCustomerGenericForm: genericFormInterface[] = [];
	selectedCustomerList = '';
	lastSelectedTag: knowledgeManagementTagsInterface = null;
	classificationStep = '';
	selectedClassificationTab = 'classification';

	kmClassification: kmClassificationInterface = {
		idCustomer: '',
		customer: '',
		id_solution_area: '',
		solution_area: '',
		cmdb: {
			idCmdb: '',
			identification: '',
		},
		request: {
			id: '',
			summary: '',
		},
		classification: {
			id_scope: '',
			id_topic: '',
			id_category: '',
			scope: '',
			topic: '',
			category: '',
		},
	};
	// kmClassificationArray: kmClassificationInterface[] = [];

	searchFormRequest: genericFormInterface[] = [];
	requestList: requestInterface[] = [];
	requestListIAC: iacOptionInterface[] = [];

	responsibleList: [] = [];
	responsibleListIAC: iacOptionInterface[] = [];

	lockClassificationGroup = '';
	lockClassificationGroupName = '';
	//Control for the notification dot on the tab
	notifyAddedClassification = false;
	notifyAddedRequest = false;
	notifyAddedCmdb = false;

	//End of Draft form
	logs: logInterface[] = [];

	newLog: logInterface = {
		idLog: '-1',
		duration: '',
		analyst: '',
		log_date: '',
		notes: '',
		status: 'Internal Comment',
	};

	reproveLog: logInterface = {
		idLog: '-1',
		duration: '',
		analyst: '',
		log_date: '',
		notes: '',
		status: 'Reproved',
	};

	ghostResizeBar = {
		mouseDown: false,
		startX: null,
		mainCol: 40,
		subCol: 60,
	};

	/* Busca de artigos  */
	tabVisible: { [key: string]: boolean } = {
		customer: false,
		tags: false,
		classification: false,
	};

	searchAvailableCustomerGenericForm: genericFormInterface[] = [];
	searchCustomerList = [];
	searchCustomerListIAC: iacOptionInterface[] = [];

	searchClassificationForm: any;
	searchFormRequestArticle: genericFormInterface[] = [];

	clearValuesResponsible = false;

	searchKbInterface = {
		customer: [],
		language: '',
		visibility: '',
		responsible: '',
		tags: [],
		classification: {},
	};

	paginationStart = 0;
	paginationEnd = 0;
	searchKbList: any[] = [];
	requestViewPaginationStart = 0;
	requestViewPaginationEnd = 0;
	classificationCustomerTableHeader: mspTableHeaderI[] = [
		{ name: 'id', value: 'ID', colWidth: '30dvw', colType: 'text' },
		{ name: 'summary', value: 'lbl_geral_summary', colWidth: '70dvw', colType: 'text' },
	];

	searchHeader: mspTableHeaderI[] = [
		{ name: 'id', value: 'ID', colType: 'text' },
		{ name: 'summary', value: 'lbl_titulo_artigo', colType: 'text' },
		{ name: 'customer', value: 'lbl_geral_cliente', colType: 'text' },
		{ name: 'language', value: 'lbl_geral_idioma', colType: 'text' },
		{ name: 'visibility', value: 'lbl_geral_visibilidade', colType: 'text' },
		{ name: 'responsible', value: 'lbl_geral_responsavel', colType: 'text' },
	];

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.KnowledgeBasePageService.getAvailableCustomer().subscribe((res) => {
			this.searchAvailableCustomerGenericForm = res;
		});

		this.ActivatedRoute.params.subscribe((parameter) => {
			if (parameter && parameter.idKb) {
				this.getKbArchive(parameter.idKb);
				this.secondColView = 'kb';
			} else {
				this.isLoadingForm = false;
			}
		});

		this.KnowledgeBasePageService.getAnalysts().subscribe((availableUsers) => {
			for (const user of availableUsers) {
				const userIAC: iacOptionInterface = {
					name: user.analyst.fullName,
					value: user.analyst.id,
				};
				this.responsibleListIAC.push(userIAC);
			}
		});

		// this.KnowledgeBasePageService.getMySolutionArea().subscribe(solutionAreas => {
		//   this.availableSolutionArea = solutionAreas;
		//   this.availableSolutionArea.forEach(solutionArea => {
		//     let newIac: iacOptionInterface = {
		//       "name":solutionArea.label,
		//       "value":solutionArea.id,
		//       "commonGroup":solutionArea.customer
		//     }
		//     this.availableSolutionAreaIAC.push(newIac);
		//   })
		//   this.isLoadingSolutionArea = false;
		// })

		this.KnowledgeBasePageService.getRequestSearchForm().subscribe((searchFormRequest) => {
			this.searchFormRequest = [...searchFormRequest];
		});

		this.classificationOptions.selectedCustomer = this.ProfileService.userData().idCustomer;
		this.userLanguage = this.ProfileService.userData().language.toLowerCase();

		this.getKbAccordion();
	}

	getKbAccordion(): void {
		this.selectedAccordion = {
			id: '',
			name: '',
			kb: [],
			type: 'kb',
			dataType: 'kb',
			border: '',
			alert: false,
			accordionLength: 0,
			hidden: false,
		};
		this.KnowledgeBasePageService.getKbAccordion().subscribe((kbAccordion) => {
			this.kbAccordion = kbAccordion;
			this.isLoadingAccordion = false;
		});
	}

	cleanKbAccordion(): void {
		this.selectedAccordion = {
			id: '',
			name: '',
			kb: [],
			type: 'kb',
			dataType: 'kb',
			border: '',
			alert: false,
			accordionLength: 0,
			hidden: false,
		};
	}

	getKbArchive(idKb: string): void {
		this.isLoadingKbArchive = true;
		this.cleanEntireArchive();

		window.history.replaceState(null, '', '/knowledgebase/' + idKb);
		this.KnowledgeBasePageService.getKbArchive(idKb).subscribe((archive) => {
			this.selectedKb = archive;

			/*if (this.selectedKb.status != 'New' && this.selectedKb.status != 'Draft')
        this.draftStep = null;
      let addedCustomer = [];
      this.selectedKb.classification.forEach((classification) => {
        if (!addedCustomer.includes(classification.idCustomer)) {
          addedCustomer.push(classification.idCustomer);
        }
        this.selectedCustomerList = this.selectedCustomerList.slice(
          this.selectedCustomerList.length - 1,
          1
        );
      });
      for (
        let i = 0;
        i < this.availableCustomerGenericForm[0].items.length;
        i++
      ) {
        let customer = this.availableCustomerGenericForm[0].items[i];
        if (!addedCustomer.includes(customer.values[0])) continue;

        this.availableCustomerGenericForm[0].values.push(customer);
        this.availableCustomerGenericForm[0].rawValues.push(customer.values[0]);
      }

      this.selectedKb.customer = this.availableCustomerGenericForm[0].values;
      this.selectedCustomerList =
        this.availableCustomerGenericForm[0].rawValues.join(',');
      */
			// this.KnowledgeBasePageService.getMySolutionArea(this.selectedKb.id_customer).subscribe(solutionAreas => {
			//   this.availableGeneralSolutionArea = solutionAreas;
			// })

			this.lockClassificationGroup = this.selectedKb.classification[0] ? this.selectedKb.classification[0].id_solution_area : '';
			this.lockClassificationGroupName = this.selectedKb.classification[0] ? this.selectedKb.classification[0].solution_area : '';
			if (this.selectedKb.status != 'New') this.getAvailableCustomer();
			if (this.selectedKb.status != 'New' && this.selectedKb.status != 'Draft') this.draftStep = null;

			this.isLoadingForm = false;
			this.isLoadingKbArchive = false;
		});

		this.getLogs(idKb);
	}

	redirectTo(to: string): void {
		this.Router.navigate([to]);
	}

	nextDraftStep(actualStep: string): void {
		//Switch is being used to cascate form validation, since you can navigate between tabs and change stuff
		//each foward step needs to validate all previous steps before going on
		let canContinue = true;
		switch (actualStep) {
			case 'content': {
				if (this.selectedKb.summary.trim() == '' || this.selectedKb.description.trim() == '') {
					this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_conteudo_artigo);
					canContinue = false;
				}
			}

			case 'classification': {
				if (this.selectedKb.classification.length === 0) {
					this.NotificationService.setNotificationMessage(this.labels.lbl_adicione_relacionamento_continuar);
					canContinue = false;
				}

				let hasSolutionArea = false;
				for (let index = 0; index < this.selectedKb.classification.length; index++) {
					const classification = this.selectedKb.classification[index];
					if (classification.id_solution_area) {
						hasSolutionArea = true;
						break;
					}
				}
				if (!hasSolutionArea) {
					this.NotificationService.setNotificationMessage(this.labels.lbl_necessario_pelo_menos_um_relacionamento);
					canContinue = false;
				}
			}

			case 'tags': {
				if (this.selectedKb.tags.length === 0) {
					this.NotificationService.setNotificationMessage(this.labels.lbl_selecione_uma_tag_relacionar);
					canContinue = false;
				}
			}

			case 'customer': {
				if (
					this.availableCustomerGenericForm.length === 0 ||
					this.availableCustomerGenericForm[0].values.length === 0 ||
					this.selectedKb.visibility == '' ||
					this.selectedKb.language == ''
				) {
					this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_informacoes_visibilidade_continuar);
					canContinue = false;
				}
			}
		}

		if (!canContinue) return;

		//Going to visibility
		if (actualStep == '') this.draftStep = { name: 'customer', label: 'lbl_geral_nivel_acesso' };

		//Going to tags
		if (actualStep == 'customer') {
			this.selectedKb.customer = this.availableCustomerGenericForm[0].values;
			this.selectedCustomerList = this.availableCustomerGenericForm[0].rawValues.join(',');
			this.draftStep = { name: 'tags', label: 'Tags' };
		}

		//Going to classification
		if (actualStep == 'tags') {
			this.cleanRelationType();
			this.draftStep = {
				name: 'classification',
				label: 'lbl_geral_classificacao',
			};
		}

		//Going to content
		if (actualStep == 'classification') this.draftStep = { name: 'content', label: 'lbl_geral_conteudo' };

		//Going to resume
		if (actualStep == 'content') this.draftStep = { name: 'resume', label: 'lbl_projetos_resumo' };
	}

	tapNewCustomer(): void {
		if (this.selectedKb.classification.length > 0) {
			this.selectedKb.classification = [];
			this.NotificationService.setNotificationMessage(this.labels.lbl_km_classificacoes_redefinidas);
		}
		this.cleanRelationType();
	}

	setLastSelectedTag(selectedTag: knowledgeManagementTagsInterface[]): void {
		this.lastSelectedTag = selectedTag.length === 0 ? null : selectedTag.at(-1);
	}

	setDraftTag(): void {
		let hasSelectedTag = false;
		for (let index = 0; index < this.selectedKb.tags.length; index++) {
			const tag = this.selectedKb.tags[index];
			if (this.lastSelectedTag.id != tag.id) continue;
			hasSelectedTag = true;
		}
		if (this.lastSelectedTag == undefined || hasSelectedTag) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_ja_adicionou_tag);
			return;
		}
		this.selectedKb.tags.push(this.lastSelectedTag);
	}

	setClassificationCustomer(customer: any): void {
		const idCustomer = customer.split(',')[0];
		const nameCustomer = customer.split(',')[1];
		this.kmClassification.idCustomer = '';
		this.classificationOptions.selectedCustomer = '';

		setTimeout(() => {
			this.kmClassification.idCustomer = idCustomer;
			this.kmClassification.customer = nameCustomer;
			this.classificationOptions.selectedCustomer = idCustomer;
		}, 100);
	}

	addClassification(): void {
		if (this.classificationStep == 'classification') {
			if (this.kmClassification.classification.id_topic == '') {
				this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_campos_novo_relacionamento);
				return;
			}

			this.selectedKb.classification.push(JSON.parse(JSON.stringify(this.kmClassification)));
			this.lockClassificationGroup = this.selectedKb.classification[0].id_solution_area;
			this.lockClassificationGroupName = this.selectedKb.classification[0].solution_area;
			this.notifyAddedClassification = true;
		}

		if (this.classificationStep == 'request') {
			if (this.kmClassification.request.id == '') {
				this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_campos_novo_relacionamento);
				return;
			}

			this.selectedKb.classification.push(JSON.parse(JSON.stringify(this.kmClassification)));
			this.lockClassificationGroup = this.selectedKb.classification[0].id_solution_area;
			this.lockClassificationGroupName = this.selectedKb.classification[0].solution_area;
			this.notifyAddedRequest = true;
		}

		if (this.classificationStep == 'cmdb') {
			if (this.kmClassification.cmdb.idCmdb == '') {
				this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_campos_novo_relacionamento);
				return;
			}

			this.selectedKb.classification.push(JSON.parse(JSON.stringify(this.kmClassification)));
			this.notifyAddedCmdb = true;
		}

		this.cleanRelationType();
	}

	removeClassification(index: number): void {
		this.selectedKb.classification.splice(index, 1);
		if (this.unlockClassification()) this.lockClassificationGroup = '';
	}

	unlockClassification(): boolean {
		let canUnlockClassification = true;
		for (let index = 0; index < this.selectedKb.classification.length; index++) {
			const classification = this.selectedKb.classification[index];
			if (classification.id_solution_area == '') continue;
			canUnlockClassification = false;
			break;
		}
		return canUnlockClassification;
	}

	cleanEntireArchive(): void {
		this.isLoadingForm = true;
		this.selectedKb = {
			id: '',
			summary: '',
			description: '',
			status: 'New',
			visibility: '',
			language: '',
			active: null,
			approved: null,
			responsible: {
				id: '',
				fullName: '',
			},

			tags: [],
			classification: [],
			customer: [],
		};
		this.logs = [];
		this.selectedCustomerList = '';
		this.availableCustomerGenericForm = [];
		this.lockClassificationGroup = '';
		this.lockClassificationGroupName = '';
		this.draftStep = {
			name: 'customer',
			label: 'lbl_geral_cliente',
		};
		this.selectedTab = 'archiveData';
		this.selectedLogType = 'Registry';

		this.cleanRelationType();

		// Carregando items relacionado a tela de busca de artigos
		this.getCustomersForSearch();
		setTimeout(() => {
			this.isLoadingForm = false;
		}, 100);
	}

	cleanRelationType(): void {
		this.classificationStep = '';

		this.kmClassification.idCustomer = '';
		this.kmClassification.customer = '';
		this.kmClassification.cmdb.idCmdb = '';
		this.kmClassification.cmdb.identification = '';
		this.kmClassification.request.id = '';
		this.kmClassification.request.summary = '';
		this.kmClassification.classification.id_scope = '';
		this.kmClassification.classification.scope = '';
		this.kmClassification.classification.id_category = '';
		this.kmClassification.classification.category = '';
		this.kmClassification.classification.id_topic = '';
		this.kmClassification.classification.topic = '';

		this.requestList = [];
		this.requestListIAC = [];
		for (const formItem of this.searchFormRequest) {
			formItem.values[0] = '';
		}

		if (this.unlockClassification()) {
			this.kmClassification.id_solution_area = '';
			this.kmClassification.solution_area = '';
		}

		this.classificationStep = '';
	}

	cleanLog(): void {
		this.reproveLog = {
			idLog: '-1',
			duration: '',
			analyst: '',
			log_date: '',
			notes: '',
			status: 'Reproved',
		};
	}

	updateVersion(quantity: 1 | 0.1): void {
		if (!this.selectedKb.version || this.selectedKb.version === '') this.selectedKb.version = '0.0';

		const splitVersion = this.selectedKb.version.toString().split('.');
		let index: 0 | 1 = null;
		if (quantity === 1) index = 0;
		if (quantity === 0.1) index = 1;

		splitVersion[index] = (Number.parseInt(splitVersion[index]) + 1).toString();

		this.selectedKb.version = Number.parseFloat(`${splitVersion[0]}.${splitVersion[1]}`);
	}

	setClassification(classification: string): void {
		this.kmClassification.request.id = '';
		this.kmClassification.request.summary = '';
		this.kmClassification.cmdb.idCmdb = '';
		this.kmClassification.cmdb.identification = '';

		const requestClassification: any = JSON.parse(classification);

		this.kmClassification.classification.id_scope = requestClassification.scope[0] ? requestClassification.scope[0].id : '';
		this.kmClassification.classification.id_category = requestClassification.category[0] ? requestClassification.category[0].id : '';
		this.kmClassification.classification.id_topic = requestClassification.topic[0] ? requestClassification.topic[0].id : '';

		this.kmClassification.classification.scope = requestClassification.scope[0] ? requestClassification.scope[0].name : '';
		this.kmClassification.classification.category = requestClassification.category[0] ? requestClassification.category[0].name : '';
		this.kmClassification.classification.topic = requestClassification.topic[0] ? requestClassification.topic[0].name : '';

		this.kmClassification.id_solution_area = requestClassification.solutionArea[0] ? requestClassification.solutionArea[0].id : '';
		this.lockClassificationGroup = requestClassification.solutionArea[0] ? requestClassification.solutionArea[0].id : null;
		this.lockClassificationGroupName = requestClassification.solutionArea[0] ? requestClassification.solutionArea[0].name : null;
		this.kmClassification.solution_area = requestClassification.solutionArea[0] ? requestClassification.solutionArea[0].name : '';
	}

	getAvailableCustomer(): void {
		if (this.kmClassification.id_solution_area != '' && this.availableCustomerGenericForm.length > 0) return;
		if (!this.kmClassification.id_solution_area || this.kmClassification.id_solution_area == '') {
			this.availableCustomerGenericForm = [];
			return;
		}
		this.isLoadingAvailableCustomer = true;
		this.KnowledgeBasePageService.getAvailableCustomer(this.kmClassification.id_solution_area).subscribe((availableCustomer) => {
			this.availableCustomerGenericForm = availableCustomer;

			if (this.selectedKb.status != 'New' && this.selectedKb.classification?.length > 0) {
				const addedCustomer = [];
				for (const classification of this.selectedKb.classification) {
					if (!addedCustomer.includes(classification.idCustomer)) {
						addedCustomer.push(classification.idCustomer);
					}
					this.selectedCustomerList = this.selectedCustomerList.slice(-1, 1);
				}
				for (let index = 0; index < this.availableCustomerGenericForm[0].items.length; index++) {
					const customer = this.availableCustomerGenericForm[0].items[index];
					if (!addedCustomer.includes(customer.values[0])) continue;

					this.availableCustomerGenericForm[0].values.push(customer);
					this.availableCustomerGenericForm[0].rawValues.push(customer.values[0]);
				}

				this.selectedKb.customer = this.availableCustomerGenericForm[0].values;
				this.selectedCustomerList = this.availableCustomerGenericForm[0].rawValues.join(',');
			}
			this.isLoadingAvailableCustomer = false;
		});
	}

	setRequestData(id: string): void {
		this.kmClassification.cmdb.idCmdb = '';
		this.kmClassification.cmdb.identification = '';
		this.kmClassification.classification.id_scope = '';
		this.kmClassification.classification.id_category = '';
		this.kmClassification.classification.id_topic = '';
		this.kmClassification.classification.scope = '';
		this.kmClassification.classification.category = '';
		this.kmClassification.classification.topic = '';

		for (let index = 0; index < this.requestList.length; index++) {
			const request = this.requestList[index];
			if (request.id != id) continue;

			this.kmClassification.request.id = request.id;
			this.kmClassification.request.summary = request.summary;
			this.kmClassification.id_solution_area = request.id_solution_area;
			this.kmClassification.solution_area = request.solution_area;
			return;
		}
	}

	setCmdb(cmdb: any): void {
		this.kmClassification.request.id = '';
		this.kmClassification.request.summary = '';
		this.kmClassification.classification.id_scope = '';
		this.kmClassification.classification.id_category = '';
		this.kmClassification.classification.id_topic = '';
		this.kmClassification.classification.scope = '';
		this.kmClassification.classification.category = '';
		this.kmClassification.classification.topic = '';

		cmdb = JSON.parse(cmdb);

		this.kmClassification.cmdb.idCmdb = cmdb.cmdb_id;
		this.kmClassification.cmdb.identification = cmdb.identification;
	}

	kbClassificationFilter(classification: kmClassificationInterface): boolean {
		if (this.selectedClassificationTab == 'cmdb') return classification.cmdb.idCmdb != '';
		if (this.selectedClassificationTab == 'request') return classification.request.id != '';
		if (this.selectedClassificationTab == 'classification') return classification.classification.topic != '';
	}

	setResponsible(id: any) {
		this.selectedKb.responsible.id = id;
	}

	createKb(): void {
		if (this.isLoadingNextStep) return;
		if (!this.areFieldsFulfilled()) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			return;
		}

		this.isLoadingNextStep = true;

		if (this.selectedKb.to_publisher === 1) {
			this.selectedKb.status = 1;
		}

		this.KnowledgeBasePageService.postKbArchive(this.selectedKb).subscribe(
			(res) => {
				res = res[0];
				this.getKbArchive(res.id);

				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
				this.getLogs();
				this.getKbAccordion();
				this.isLoadingNextStep = false;
			},
			(errorRes) => {
				this.isLoadingNextStep = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_sem_permissao_acao);
			}
		);
	}

	updateKb(nextStatus?: string): void {
		if (this.isLoadingNextStep) return;
		if (!this.areFieldsFulfilled()) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			return;
		}

		this.isLoadingNextStep = true;

		if (this.reproveLog.idLog === '') {
			this.KnowledgeBasePageService.postKbLog(this.selectedKb, this.reproveLog).subscribe(() => {
				this.cleanLog();

				this.KnowledgeBasePageService.putKbArchive(this.selectedKb, nextStatus).subscribe(
					(res) => {
						res = res[0];

						this.selectedKb.status = typeof res.status === 'number' ? this.availableStatus[res.status] : res.status;

						this.getKbAccordion();
						this.isLoadingNextStep = false;
					},
					(errorRes) => {
						this.isLoadingNextStep = false;
						this.NotificationService.setNotificationMessage(this.labels.lbl_sem_permissao_acao);
					}
				);
			});
		} else {
			this.KnowledgeBasePageService.putKbArchive(this.selectedKb, nextStatus).subscribe(
				(res) => {
					res = res[0];
					this.selectedKb.responsible = res.responsible;
					this.selectedKb.status = typeof res.status === 'number' ? this.availableStatus[res.status] : res.status;

					this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);

					this.getKbAccordion();
					this.isLoadingNextStep = false;
				},
				(errorRes) => {
					this.isLoadingNextStep = false;
					this.NotificationService.setNotificationMessage(this.labels.lbl_sem_permissao_acao);
				}
			);
		}
	}

	deleteKb(): void {
		this.KnowledgeBasePageService.deleteKbArchive(this.selectedKb).subscribe(
			(res) => {
				this.cleanEntireArchive();
				this.getKbAccordion();
				this.Router.navigate(['/knowledgebase']);
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_deletado_com_sucesso);
			},
			(errorRes) => {
				this.isLoadingNextStep = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_sem_permissao_acao);
			}
		);
	}

	getLogs(idKb?: string): void {
		if (!idKb) idKb = this.selectedKb.id;
		this.isLoadingKbLogs = true;
		this.KnowledgeBasePageService.getKbLogs(idKb).subscribe((logs) => {
			this.logs = logs;
			this.isLoadingKbLogs = false;
		});
	}

	createLog(): void {
		this.logs.push({ ...this.newLog });
		this.KnowledgeBasePageService.postKbLog(this.selectedKb, this.newLog).subscribe((res) => {
			this.newLog.notes = '';
		});
	}

	changeHistory(newHistory: string): void {
		window.history.replaceState(null, '', newHistory);
	}

	areFieldsFulfilled(): boolean {
		return true;
	}

	handleGhostResizeBar(e: MouseEvent): void {
		if (!this.ghostResizeBar.mouseDown) return;
		this.ghostResizeBar.subCol = 100 - (e.pageX / (window.innerWidth + 64)) * 100;
		this.ghostResizeBar.mainCol = (e.pageX / (window.innerWidth + 64)) * 100;
	}

	searchRequest(): void {
		if (this.isLoadingSearchRequest) return;

		let atLeastOneFieldFulfilled = false;
		for (const formItem of this.searchFormRequest) {
			if (formItem.values && formItem.values[0] !== '') atLeastOneFieldFulfilled = true;
			continue;
		}

		if (!atLeastOneFieldFulfilled) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_pelo_menos_um_campo_para_continuar);
			return;
		}

		this.requestListIAC = [];
		this.requestList = [];
		this.isLoadingSearchRequest = true;
		const customer = [this.kmClassification.idCustomer];

		this.KnowledgeBasePageService.getRequest(this.searchFormRequest, customer, this.lockClassificationGroup).subscribe(
			(requestList) => {
				this.isLoadingSearchRequest = false;
				this.requestList = requestList;
				for (const request of this.requestList) {
					const newRequestIAC: iacOptionInterface = {
						name: request.summary,
						value: request.id,
						commonGroup: request.id,
					};
					this.requestListIAC.push({ ...newRequestIAC });
				}

				if (this.requestListIAC.length === 0 && this.requestList.length === 0) {
					this.NotificationService.setNotificationMessage(this.labels.lbl_security_nenhum_registro);
					return;
				}
			},
			() => {
				this.isLoadingSearchRequest = false;
			}
		);
	}

	searchSelectCustomerFilter() {
		this.searchKbInterface.customer = this.availableCustomerGenericForm[0].rawValues;
	}

	searchSelectTagFilter(): void {
		let hasSelectedTag = false;
		for (let index = 0; index < this.selectedKb.tags.length; index++) {
			const tag = this.selectedKb.tags[index];
			if (this.lastSelectedTag.id != tag.id) continue;
			hasSelectedTag = true;
		}
		if (this.lastSelectedTag == undefined || hasSelectedTag) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_ja_adicionou_tag);
			return;
		}
		this.searchKbInterface.tags.push(this.lastSelectedTag);
	}

	setClassificationFilter(event) {
		this.searchClassificationForm = JSON.parse(event);
	}

	getCustomersForSearch(): void {
		// Classification - Customer
		this.searchCustomerListIAC = [];
		for (const customer of this.searchAvailableCustomerGenericForm[0]?.items ?? []) {
			const newIac: iacOptionInterface = {
				name: customer.label,
				value: customer.values[0],
			};
			this.searchCustomerListIAC.push(newIac);
		}
	}

	searchArticles() {
		this.searchKbInterface.classification = [...this.selectedKb.classification];
		this.KnowledgeBasePageService.getKbsWithFilters(this.searchKbInterface).subscribe((resp) => {
			this.searchKbList = resp;
		});
	}

	cleanArticlesList(): void {
		this.searchKbList = [];
		this.searchKbInterface = {
			customer: [],
			language: '',
			visibility: '',
			responsible: '',
			tags: [],
			classification: {},
		};

		this.searchAvailableCustomerGenericForm[0].rawValues = [];
		this.searchAvailableCustomerGenericForm[0].values = [];
		this.selectedKb.classification = [];

		if (this.unlockClassification()) {
			this.kmClassification.id_solution_area = '';
			this.kmClassification.solution_area = '';
		}

		this.clearValuesResponsible = true;
		setTimeout(() => {
			this.clearValuesResponsible = false;
		}, 1);
	}

	sort(event) {}

	searchResponsible(event) {
		this.searchKbInterface.responsible = event;
	}

	// Função para fechar o modal ao ser clicado em áreas que não fazem parte do modal
	modalClose(event: Event, ignorePropagation: boolean): void {
		if (event.target === document.querySelector('#modalClose')) {
			this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
		}
		if (ignorePropagation) {
			this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
		}
	}

	openModalEvaluationMSP() {
		this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
	}
	// Final Função para fechar o modal ao ser clicado em áreas que não fazem parte do modal

	toggleArrowRotation(tab: string) {
		this.tabVisible[tab] = !this.tabVisible[tab];
	}
}
